import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["defaultBlogId", "defaultOptions", "readOnly", "required", "scopes", "showCreationOption", "type", "value", "isCreationOptionLocked", "options"];
/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { Component, Fragment } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import { connect } from 'react-redux';
import { debounce, isEqual, memoize } from 'underscore';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { LanguageIcon } from 'foundations-assets';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { Button } from 'foundations-components/transitional/components/Button';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import * as blogsSelectors from 'ContentData/selectors/blogs';
import * as BlogsActions from 'ContentData/actions/Blogs';
import { DEFAULT_PAGE_SIZE, ASYNC_SELECTOR_DEBOUNCE } from '../constants';
import AsyncSelector from '../components/AsyncSelector';
// @ts-expect-error no types yet
import { QuickBlogCreationModal } from '../../modals/QuickBlogCreationModal';
import { SUCCEEDED, PENDING } from 'ContentUtils/constants/RequestStatus';
import { DEFAULT } from 'ContentUtils/constants/Blogs';
import { BLOG } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import hashString from 'ContentComponents/utils/hashString';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = suffix => `ContentComponents.cmv2.fields.blog.${suffix}`;
const languageI18nKey = key => `SharedI18nStrings.languageNames.${key}`;
const hashBlogOptions = options => {
  return `${hashString(options.reduce((blogIds, option) => `${blogIds}${blogIds && '.'}${option && option.value || null}`, ''))}`;
};
const mapStateToProps = (state, props) => {
  return {
    blog: blogsSelectors.getBlog(state, {
      id: props.value
    }),
    blogsCache: blogsSelectors.getBlogsCache(state),
    options: blogsSelectors.getBlogOptions(state),
    optionsRequestStatus: blogsSelectors.getBlogsCacheRequestStatus(state),
    defaultOptions: blogsSelectors.getDefaultBlogOptions(state),
    defaultBlogId: blogsSelectors.getDefaultBlogId(state),
    defaultBlogFetchStatus: blogsSelectors.getDefaultBlogFetchStatus(state)
  };
};
const mapDispatchToProps = {
  fetchBlog: BlogsActions.fetchBlog,
  fetchBlogs: BlogsActions.fetchBlogs,
  fetchDefaultBlog: BlogsActions.fetchDefaultBlog,
  saveCache: BlogsActions.saveCache,
  clearCache: BlogsActions.clearCache,
  succeedCreateBlog: BlogsActions.succeedCreateBlog,
  failCreateBlog: BlogsActions.failCreateBlog
};
const connector = connect(mapStateToProps, mapDispatchToProps);
class Blog extends Component {
  constructor(props) {
    super(props);
    this.blogOptionsWithLanguage = memoize(options => {
      return options.map(option => {
        const {
          value: blogId
        } = option;
        return Object.assign({}, option, {
          help: this.renderBlogLanguage(blogId)
        });
      }).sort((option1, option2) => {
        const option1Language = this.getBlogLanguage(option1.value);
        const option2Language = this.getBlogLanguage(option2.value);
        return option1.text.localeCompare(option2.text) || option1Language.localeCompare(option2Language);
      });
    }, options => hashBlogOptions(options));
    this.onChange = this.onChange.bind(this);
    this.loadOptions = this.loadOptions.bind(this);
    this.handleCancelCreate = this.handleCancelCreate.bind(this);
    this.handleCreateBlogClick = this.handleCreateBlogClick.bind(this);
    this.handleCreateBlogSuccess = this.handleCreateBlogSuccess.bind(this);
    this.debouncedLoadOptions = debounce(this.loadOptions, ASYNC_SELECTOR_DEBOUNCE);
    this.state = {
      input: '',
      blogCreationModalOpen: false
    };
  }
  componentDidMount() {
    const {
      fetchBlog,
      fetchDefaultBlog,
      value
    } = this.props;
    if (value) {
      if (value === DEFAULT) {
        fetchDefaultBlog();
      } else {
        fetchBlog(value);
      }
    }
  }
  componentDidUpdate(prevProps) {
    const {
      blog,
      fetchBlog,
      fetchDefaultBlog,
      value,
      defaultBlogId,
      defaultBlogFetchStatus
    } = this.props;
    const {
      value: prevValue
    } = prevProps;
    const {
      defaultBlogFetchStatus: prevDefaultBlogFetchStatus
    } = prevProps;
    if (!isEqual(prevValue, value) && !blog) {
      if (value === DEFAULT && !defaultBlogId) {
        fetchDefaultBlog();
      } else {
        fetchBlog(value);
      }
    }
    if (prevDefaultBlogFetchStatus === PENDING && defaultBlogFetchStatus === SUCCEEDED) {
      fetchBlog(defaultBlogId);
    }
  }
  loadOptions(input, callback, pagination = {
    offset: 0
  }) {
    const {
      clearCache,
      fetchBlogs
    } = this.props;
    let offset = pagination.offset;
    if (input !== this.state.input) {
      this.setState({
        input
      });
      clearCache();
      offset = 0;
    }
    const query = {
      name__icontains: input,
      limit: DEFAULT_PAGE_SIZE,
      offset
    };
    fetchBlogs(query).then(response => {
      const {
        total
      } = response;
      callback(null, {
        options: this.blogOptionsWithLanguage(this.props.options),
        pagination: {
          hasMore: total > this.props.options.length,
          offset: offset + DEFAULT_PAGE_SIZE,
          length: total
        }
      });
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }
  onChange(evt) {
    const {
      onChange,
      onFieldChange = emptyFunction
    } = this.props;
    if (onChange) {
      onChange(evt);
    } else {
      onFieldChange(evt.target.value);
    }
  }
  handleCancelCreate() {
    this.setState({
      blogCreationModalOpen: false
    });
  }
  handleCreateBlogClick() {
    const {
      onClickCreateBlog = emptyFunction,
      onClickCreateBlogWithLimitReached = emptyFunction,
      isBlogLimitReached
    } = this.props;
    if (!isBlogLimitReached) {
      onClickCreateBlog();
      this.setState({
        blogCreationModalOpen: true
      });
    } else {
      onClickCreateBlogWithLimitReached();
    }
  }
  handleCreateBlogSuccess(blog) {
    this.props.succeedCreateBlog(blog);
    this.onChange({
      target: {
        value: blog.id
      }
    });
    this.setState({
      blogCreationModalOpen: false
    });
  }
  getBlogLanguage(blogId) {
    const {
      blogsCache = {}
    } = this.props;
    const blog = blogsCache[blogId];
    return blog && blog.language ? blog.language : '';
  }
  renderBlogLanguage(blogId) {
    const {
      blogsCache = {}
    } = this.props;
    const blog = blogsCache[blogId];
    if (!(blog && blog.language)) return null;
    const isPrimaryLanguageVariant = !blog.translatedFromId && Object.keys(blog.translations).length;
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "100",
      children: [/*#__PURE__*/_jsx(LanguageIcon, {
        size: "100"
      }), isPrimaryLanguageVariant ? /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: i18nKey('primaryLanguageVariant'),
        options: {
          language: /*#__PURE__*/_jsx(FormattedMessage, {
            message: languageI18nKey(blog.language)
          })
        }
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: languageI18nKey(blog.language)
      })]
    });
  }
  render() {
    const _this$props = this.props,
      {
        defaultBlogId,
        defaultOptions,
        readOnly,
        required = false,
        scopes,
        showCreationOption = false,
        type = BLOG,
        value,
        isCreationOptionLocked = false,
        options
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    let selectValue = value;

    // this populates the select with the default blog ID if the value is "default"
    if (value === DEFAULT) selectValue = defaultBlogId;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(AsyncSelector, Object.assign({
        "data-selenium": "blog-select",
        dropdownFooter: showCreationOption ? /*#__PURE__*/_jsxs(Button, {
          "data-test-id": "create-blog-button",
          onClick: this.handleCreateBlogClick,
          use: "link",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('createBlogButtonText')
          }), isCreationOptionLocked && /*#__PURE__*/_jsx(LockBadge, {})]
        }) : null,
        clearable: !required,
        loadOptions: this.debouncedLoadOptions,
        onChange: this.onChange,
        readOnly: readOnly,
        type: type
      }, rest, {
        defaultOptions: defaultOptions,
        options: this.blogOptionsWithLanguage(options),
        value: selectValue
      })), showCreationOption && this.state.blogCreationModalOpen ? /*#__PURE__*/_jsx(QuickBlogCreationModal, {
        onBlogCreateSuccess: this.handleCreateBlogSuccess,
        onCancel: this.handleCancelCreate,
        scopes: scopes
      }) : null]
    });
  }
}
Blog.defaultProps = {
  required: false,
  showCreationOption: false,
  isCreationOptionLocked: false,
  isBlogLimitReached: false
};
export default connector(Blog);